import { Route, Routes } from 'react-router-dom';
import LeadSettings from './LeadSettings.tsx';
import CampaignLeadsList from './CampaignLeadsList.tsx';
import CreateEditStatusSubStatus from './StatusAndSubStatus/index.tsx';
import CreateEditLeadForm from './LeadForm/CreateEditLeadForm.tsx';
import List from './StatusAndSubStatus/List.tsx';
import CampaignMappingList from './CampaignMapping/CampaignMappingList.tsx';
import EditLeadForm from './EditLeadForm/index.tsx';
import EnterLeads from './EnterLeads.tsx';
import ImportRecordsPage from '../../features/business-functions/records/pages/ImportRecordsPage';
import MapViewComponent from './MapView/MapViewComponent.tsx';
import CreateEditSchedular from './Schedular/index.tsx';
import LeadsV1 from './V1/index.tsx';
import ManageAction from './V1/ManageActionModal.tsx';
import CreateReportFormat from './V1/Report/CreateReportFormat.tsx';
import ReportViewer from './V1/Report/ReportViewer.tsx';
import HtmlPreview from './V1/Report/HtmlPreview.tsx';
import ReportTemplates from './V1/Report/ReportTemplates.tsx';
import ViewReport from './V1/Report/View Reports/View.tsx';
import TriggerManagerPage from './V1/Report/TriggerManagerDialog.tsx';
import TriggerListPage from './V1/Report/TriggerListPage.tsx';
import HelpFile from './LeadForm/HelpFile.tsx';

const Leads = () => {
  return (
    <Routes>
      <Route exact path="/v1" element={<LeadsV1 />} />
      <Route path="/templates/:templateId/triggers/create" element={<TriggerManagerPage />} />
      <Route path="/templates/:templateId/triggers/edit/:Id" element={<TriggerManagerPage />} />

      <Route path="/templates/:templateId/triggers/list" element={<TriggerListPage />} />

      <Route exact path="/report-list" element={<ReportTemplates />} />
      <Route exact path="/view-report" element={<ViewReport />} />
      <Route exact path="/reportViewer" element={<ReportViewer />} />
      <Route exact path="/html-preview" element={<HtmlPreview />} />
      <Route exact path="/createReportFormat" element={<CreateReportFormat />} />
      <Route exact path={'/editReportFormat/:reportId'} element={<CreateReportFormat />} />

      <Route exact path="/action" element={<ManageAction />} />

      <Route exact path={`/settings`} element={<LeadSettings />} />
      <Route exact path={`/:campaignId/importLeads/:leadFormId`} element={<ImportRecordsPage />} />
      <Route exact path={`/campaigns`} element={<CampaignLeadsList />} />
      <Route exact path={`/:campaignId/createForm`} element={<CreateEditLeadForm />} />
      <Route exact path={`/:campaignId/editForm/:leadFormId`} element={<CreateEditLeadForm />} />
      <Route
        exact
        path={`/status-create/:campaignId/:leadFormId`}
        element={<CreateEditStatusSubStatus />}
      />
      <Route
        exact
        path={`/status-update/:campaignId/:leadFormId/:statusId/`}
        element={<CreateEditStatusSubStatus />}
      />
      <Route exact path={`/status-list/:campaignId/:leadFormId`} element={<List />} />
      <Route exact path={`/:campaignId/campaign-Mapping`} element={<CampaignMappingList />} />
      <Route exact path={`/edit/:campaignId/:leadFormId`} element={<EditLeadForm />} />
      <Route
        exact
        path={`/status-create/:campaignId/:leadFormId`}
        element={<CreateEditStatusSubStatus />}
      />
      <Route
        exact
        path={`/status-update/:campaignId/:leadFormId/:statusId/`}
        element={<CreateEditStatusSubStatus />}
      />
      <Route exact path={`/schedular/:campaignId/:leadFormId`} element={<CreateEditSchedular />} />

      <Route exact path={`/:campaignId/enterLeads`} element={<EnterLeads />} />
            <Route exact path={"/help-file/:leadFormId"} element={<HelpFile />} />

    </Routes>
  );
};
export default Leads;
